import { Constants } from "../utils/constants";

export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
}



  export const formattedJsonString =(escapedJsonString)=>
  {

    // Convert the escaped JSON string to a properly formatted JSON string
const formattedJsonString = escapedJsonString.replace(/\\/g, '');

// Parse the JSON string

    return  formattedJsonString
  }
  

  export const checkIfDomainExists=(url)=>
  {
    return (url.split("/").includes("https:")? url: Constants.URL.base + url)
  }

  export const returnSingleName =(Name)=>
  {
    let nameBucket=Name.split(" ");

    if( nameBucket.length>1)
    {
      return nameBucket[0]
    }
      return  Name


  }




 


 

   


     
    

    

            export function includesIgnoreCase(source, substring) {
  return source?.toLowerCase().includes(substring.toLowerCase());
}




export function getTrueFileExtension(fileName){
  if(typeof fileName !== 'string') return "";
  const lastDot = fileName.lastIndexOf('.');
  if (lastDot === -1 || lastDot === fileName.length - 1) return "";
  const fileType = fileName.slice(lastDot + 1).toLowerCase();
  return fileType;
}





      
  